import React from "react";
import { getYouTubeEmbedUrl, getSpotifyEmbedUrl } from "../../lib/embeds";
import "./EpisodeModal.css";

export default function EpisodeModal({ episode, onClose }) {
  if (!episode) return null;
  const { title, description, date, topic, guestName, youtubeUrl, spotifyUrl } = episode;
  const ytEmbed      = getYouTubeEmbedUrl(youtubeUrl);
  const spotifyEmbed = getSpotifyEmbedUrl(spotifyUrl);

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-box" onClick={(e) => e.stopPropagation()}>
        <button className="modal-close" onClick={onClose}>✕ CLOSE</button>

        {ytEmbed && (
          <iframe
            className="modal-iframe"
            src={`${ytEmbed}?autoplay=1`}
            allow="autoplay; encrypted-media"
            allowFullScreen
            title={title}
          />
        )}
        {!ytEmbed && spotifyEmbed && (
          <iframe
            className="modal-iframe modal-iframe--audio"
            src={spotifyEmbed}
            allow="autoplay; clipboard-write; encrypted-media; fullscreen"
            title={title}
          />
        )}

        <div className="modal-info">
          <div className="modal-meta">
            {date} {topic && `· ${topic}`} {guestName && `· Guest: ${guestName}`}
          </div>
          <h2 className="modal-title">{title}</h2>
          <p className="modal-desc">{description}</p>

          {ytEmbed && spotifyEmbed && (
            <div className="modal-spotify">
              <div className="modal-spotify-label">Also on Spotify</div>
              <iframe
                style={{ width: "100%", height: 80, border: "none" }}
                src={spotifyEmbed}
                allow="autoplay; clipboard-write; encrypted-media"
                title="spotify"
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
